import { render, staticRenderFns } from "./DadosDaCompra.vue?vue&type=template&id=be2f965e&scoped=true&"
import script from "./DadosDaCompra.vue?vue&type=script&lang=js&"
export * from "./DadosDaCompra.vue?vue&type=script&lang=js&"
import style0 from "./DadosDaCompra.vue?vue&type=style&index=0&id=be2f965e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2f965e",
  null
  
)

export default component.exports